import React, { useState, useEffect } from 'react';

const DEVICE_MODAL_DISMISSED_KEY = 'device_detector_modal_dismissed';

const DeviceDetector = () => {
  const [showModal, setShowModal] = useState(false);
  const [deviceType, setDeviceType] = useState(null);

  useEffect(() => {
    const detectDevice = () => {
      if (localStorage.getItem(DEVICE_MODAL_DISMISSED_KEY) === 'true') {
        return;
      }

      const userAgent = navigator.userAgent.toLowerCase();
      const isIpad = /ipad/.test(userAgent) || 
                    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window.MSStream);
      const isTablet = /(tablet|playbook|silk)|(android(?!.*mobile))/i.test(userAgent);
      const isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      
      if (isIpad) {
        setDeviceType('ios');
        setShowModal(true);
      } else if (isTablet) {
        setDeviceType('android');
        setShowModal(true);
      } else if (isMobile) {
        const isIOS = /iphone|ipod/.test(userAgent);
        setDeviceType(isIOS ? 'ios' : 'android');
        setShowModal(true);
      }
    };

    detectDevice();
  }, []);

  const closeModal = () => {
    localStorage.setItem(DEVICE_MODAL_DISMISSED_KEY, 'true');
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-xl">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Enjoying the Web Experience?</h2>
          
          <p className="mb-6 text-gray-600">
            Take it further with our mobile apps! Use the full power of our platform on your {" "} 
            {deviceType === 'ios' ? 'Apple' : 'Android'} {deviceType === 'ios' ? 'device' : 'tablet'} optimised for touch, speed, and convenience.
          </p>
          
          <p className="mb-6 font-semibold">Download now and stay connected on the go!</p>
          
          <div className="flex flex-wrap justify-center gap-3">
          {/* have to change those links with real links before make this app live */}
            <a 
              href={deviceType === 'ios' 
                ? "https://apps.apple.com/in/app/mathdingo/id6504842091" 
                : "https://play.google.com/store/apps/details?id=com.math.mathdingo"} 
              className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Application
            </a>
            <button 
              onClick={closeModal} 
              className="border border-blue-600 text-blue-600 px-6 py-3 rounded-lg font-semibold"
            >
              Continue on web
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceDetector;
